import axios from "axios";
import store from "../redux/store/index";
import { getURL } from "../constants/index";
import { puntToSignIn } from "./APIService";

export function genericRequest(method, url, params, data) {
    const WebAPI_URL = getURL();
    const state = store.getState();
    if (state.authReducer.user == null)
        return puntToSignIn();
    const token = state.authReducer.user.profile.token;
    const config = {
        method,
        url: WebAPI_URL + url,
        headers: {
            ...(data ? {"Content-Type": "application/json"} : {}),
            Accept: "*/*",
            Authorization: "Bearer " + token,
        },
        params,
        data
    };
    return axios(config).then((response) => {
        if (response.status === 200) {
            return response;
        } else {
            throw new Error(`Unexpected status code:` + 
                ` ${response.status}`);
        }
    });
}
